import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';

import { PipesModule } from '../../_modules/pipes.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { NotaFiscalComponent } from './notafiscal.component';
import { SharedModule } from 'app/_modules/shared.module';
import { NgScrollbarModule, provideScrollbarOptions } from 'ngx-scrollbar';
import { PdfViewerModule } from 'ng2-pdf-viewer';

export function HttpLoaderFactory(http: HttpClient) { return new TranslateHttpLoader(http); }

@NgModule({
    declarations: [NotaFiscalComponent],
    imports: [
        CommonModule,
        PdfViewerModule,
        PipesModule,
        NgScrollbarModule,
        TranslateModule.forChild({ loader: { provide: TranslateLoader, useFactory: HttpLoaderFactory, deps: [HttpClient] } }),
    ],
    exports: [
        NotaFiscalComponent,
        PipesModule,
        TranslateModule
    ],
    providers: [
        provideScrollbarOptions({
            visibility: 'hover'
        })
    ],
    bootstrap: []
})
export class NotaFiscalModule { }
